import React from 'react';

import Toolbar from './components/Toolbar/Toolbar'
import Sidebar from './components/Sidebar/Sidebar'
import Backdrop from './components/Backdrop/Backdrop'

import Routes from './routes/routes'
import ReactGA from 'react-ga';

import ScrollToTop from './components/ScrollToTop/ScrollToTop'

class App extends React.Component {
  constructor(props){
    super(props);
    this.state={
      sideDrawOpen: false,
      apiResponse: ''
    };
  }

  componentDidMount() {
    if (process.env.REACT_APP_GA_TRACKING_CODE) {
      ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE);
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  componentDidUpdate() {
    if (process.env.REACT_APP_GA_TRACKING_CODE) {
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  drawerToggleClickHandler = () => {
    this.setState((prevState) => {
      return {sideDrawOpen: !prevState.sideDrawOpen};
    });
  };

  backdropClickHandler = () =>{
    this.setState({sideDrawOpen:false});
  };

  render() {
    const styleFondo={
       background: '#10121b',
       position: 'absolute',
       top: 0,
       left: 0,
       right: 0,
       zIndex: 2,
       minWidth:'100%',
       minHeight:'100%',
    }
    let backdrop;

    if(this.state.sideDrawOpen){
      backdrop = <Backdrop click={this.backdropClickHandler}/>
    }
    return (
      <div style={styleFondo}>
        <Toolbar drawerClickHandler={this.drawerToggleClickHandler}/>
        <Sidebar show={this.state.sideDrawOpen}/>
        <ScrollToTop/>
        {backdrop}
        <Routes/>
      </div>
    )
  }
}

export default App; 